export default "__VITE_ASSET__pdQaomas__"